export default __webpack_public_path__ + "static/media/day_trade_success_unactive_account_bc.bd9ce243.svg";